import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    hero: {
      title: "CRAZY ANGRYBRICKS",
      subtitle: "The Ultimate Brick Breaker for AMSTRAD CPC",
      tagline: "Relive the golden age of retro gaming with this explosive brick breaker!"
    },
    rules: {
      title: "GAME FEATURES",
      crazyModes: {
        title: "Crazy Modes",
        description: "Random surprise effects will launch during gameplay, adding unexpected chaos and excitement to every level!"
      },
      bonuses: {
        title: "3 Power-Ups",
        description: "Collect special bonuses that give you unique advantages to dominate the bricks!"
      },
      levels: {
        title: "10 Levels + Boss",
        description: "Battle through 10 challenging levels and face an epic boss battle at the end!"
      }
    },
    screenshots: {
      title: "GAME SCREENSHOTS"
    },
    download: {
      title: "DOWNLOAD GAME",
      description: "Get Crazy AngryBricks for your AMSTRAD CPC now (compliant with 6128 and 464 classic) !",
      dskButton: "Download .DSK",
      dskDescription: "Disk image for AMSTRAD CPC emulators & Gotek (or equivalent)",
      binButton: "Download .BIN",
      binDescription: "Binary file for physical AMSTRAD CPC floppy disks"
    },
    coffee: {
      title: "SUPPORT THE DEVELOPER",
      description: "If you enjoy this game, consider supporting me with a coffee! Every donation helps me create more retro gaming experiences."
    },
    scrollDown: "SCROLL DOWN"
  },
  fr: {
    hero: {
      title: "CRAZY ANGRYBRICKS",
      subtitle: "Le Casse-Briques Ultime pour AMSTRAD CPC",
      tagline: "Revivez l'âge d'or du rétro-gaming avec ce casse-briques explosif !"
    },
    rules: {
      title: "CARACTÉRISTIQUES DU JEU",
      crazyModes: {
        title: "Modes Fous",
        description: "Des effets surprises aléatoires se déclenchent pendant le jeu, ajoutant chaos et excitation à chaque niveau !"
      },
      bonuses: {
        title: "3 Bonus",
        description: "Collectez des bonus spéciaux qui vous donnent des avantages uniques pour dominer les briques !"
      },
      levels: {
        title: "10 Niveaux + Boss",
        description: "Combattez à travers 10 niveaux difficiles et affrontez un boss épique à la fin !"
      }
    },
    screenshots: {
      title: "CAPTURES D'ÉCRAN"
    },
    download: {
      title: "TÉLÉCHARGER LE JEU",
      description: "Téléchargez Crazy AngryBricks pour votre AMSTRAD CPC, compatible version non + (6128 et 464 classic) !",
      dskButton: "Télécharger .DSK",
      dskDescription: "Image disque pour émulateurs AMSTRAD CPC et Gotek (ou équivalent)",
      binButton: "Télécharger .BIN",
      binDescription: "Fichier binaire pour disquettes AMSTRAD CPC physiques"
    },
    coffee: {
      title: "SOUTENEZ LE DÉVELOPPEUR",
      description: "Si vous aimez ce jeu, pensez à m'offrir un café ! Chaque don m'aide à créer plus d'expériences rétro-gaming."
    },
    scrollDown: "DÉFILER VERS LE BAS"
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Detect browser language on initial load
    const browserLang = navigator.language || navigator.userLanguage;
    const detectedLang = browserLang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
    setLanguage(detectedLang);
  }, []);

  const t = (path) => {
    const keys = path.split('.');
    let value = translations[language];
    for (const key of keys) {
      value = value?.[key];
    }
    return value || path;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};